import { useMutation, useQueryClient } from '@tanstack/react-query';
import { friendsQueryOptions } from '@/hooks/contacts/use-friends';
import { allChatSessionQueryOptions } from '@/hooks/sessions/use-conversation-sessions';
import { generateFriendInfoQueryOptions } from '@/hooks/users/use-friend-info';
import type { RespondedType, ResponseError } from '@/models/response';
import { useConversationSessionStore } from '@/stores/conversation-session';
import { addToast } from '@/stores/toast';
import { fetcher } from '@/utils/fetcher';

export default function useDeleteFriend(userId: number | null | undefined) {
  const queryClient = useQueryClient();

  return useMutation<RespondedType, ResponseError>({
    mutationKey: ['/DeleteFriend', userId],
    mutationFn: userId ? () => fetcher('/DeleteFriend', { UserID: userId }, { validResponseCodes: [0] }) : undefined,
    onSuccess: async (_) => {
      if (!userId) return;

      useConversationSessionStore.getState().removeSessionByUserId(userId);

      await Promise.allSettled([
        queryClient.invalidateQueries(friendsQueryOptions),
        queryClient.invalidateQueries(allChatSessionQueryOptions),
        queryClient.invalidateQueries(generateFriendInfoQueryOptions(userId)),
      ]);
    },
    onSettled: (data, error) =>
      addToast({
        type: data ? 'success' : 'error',
        message: data?.Msg ?? error?.message,
      }),
  });
}
